import { getIn } from 'formik';
import PropTypes from 'prop-types';
import { InputBox } from 'app/shared/ui';

/**
 * Connects InputBox component with formik <Field />
 * @returns {*} Wrapper component
 */
export const InputBoxField = ({
  field,
  required,
  isCheckErrorOnChange,
  form: { errors, touched, setFieldValue },
  ...props
}) => (
  <InputBox
    {...field}
    onChange={({ target: { value } }) => setFieldValue(field.name, value)}
    isRequired={required || field.required}
    errorText={
      isCheckErrorOnChange
        ? getIn(errors, field.name)
        : getIn(touched, field.name) && getIn(errors, field.name)
    }
    {...props}
  />
);

InputBoxField.propTypes = {
  isCheckErrorOnChange: PropTypes.bool,
  field: PropTypes.object.isRequired,
  required: PropTypes.bool,
  form: PropTypes.shape({
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired,
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
};

InputBoxField.defaultProps = {
  required: false,
  isCheckErrorOnChange: false,
};
